import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const SharedFooter = ({ hideSocialLinks = false }) => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = [
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Contact', href: 'mailto:hello@depthme.app' }
  ];

  return (
    <footer className="py-16 px-6 border-t border-border/50">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/brand/depthme-icon-192.png" 
                alt="DepthMe Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-semibold text-foreground">DepthMe</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              DepthMe helps you replace the thoughts holding you back — through mind reframing, your own voice, and daily rituals built around your real situation.
            </p>
          </div>

          {/* Mission Statement */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground">Our Mission</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              To make mind training accessible to everyone — so that what was programmed can be replaced, and a new thought can become a new life.
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-sm text-muted-foreground">
              © {currentYear} DepthMe. All rights reserved.
            </div>

            {/* Footer Links */}
            <div className="flex flex-wrap justify-center md:justify-end space-x-6">
              {footerLinks?.map((link) =>
                link?.to ? (
                  <Link
                    key={link?.label}
                    to={link?.to}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </Link>
                ) : (
                  <a
                    key={link?.label}
                    href={link?.href}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </a>
                )
              )}
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 pt-6 border-t border-border/30">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-xs text-muted-foreground">
              <div className="flex flex-wrap justify-center md:justify-start space-x-4">
                <div className="flex items-center space-x-1">
                  <Icon name="Lock" size={12} className="text-accent" />
                  <span>Zero-Knowledge Encrypted</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Shield" size={12} className="text-accent" />
                  <span>Your data stays yours</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="BookOpen" size={12} className="text-accent" />
                  <span>Evidence-Based</span>
                </div>
              </div>
              
              <div className="text-center md:text-right">
                <p>Made with ❤️ by Dan Mejia for your mental wellness journey 🌙</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SharedFooter;